// UI types for BOM (Bill of Materials) Management, backed by the
// /api/restaurant_bom endpoints - see services/bomService.ts.

export type BomItemType = "FINISHED" | "SEMI_FINISHED";

export interface BomIngredientMasterItem {
    ingredient_code: string;
    ingredient_name: string;
    uom: string;
    unit_cost: number;
}

export interface BomIngredientRow {
    row_id: string;
    ingredient_code: string;
    ingredient_name: string;
    uom: string;
    qty_per_1: number;
    wastage_pct: number;
    unit_cost: number;
}

export interface BomMenuItem {
    item_code: string;
    item_name: string;
    item_type: BomItemType;
    uom: string;
    // Primary image from pos_item_resources, resolved to a full URL. Null/
    // undefined when the item has no image - render the default icon instead.
    image_url?: string | null;
    yield_qty: number;
    version: number;
    // Active restaurant_bom.bom_id for this item, when a BOM already exists.
    // Undefined means the item has no BOM yet (create instead of update).
    bom_id?: number;
    ingredients: BomIngredientRow[];
}

export const computeIngredientTotalQty = (row: Pick<BomIngredientRow, "qty_per_1" | "wastage_pct">): number =>
    row.qty_per_1 * (1 + (row.wastage_pct || 0) / 100);

export const computeIngredientCost = (row: BomIngredientRow): number =>
    computeIngredientTotalQty(row) * row.unit_cost;

export const computeTotalBomCost = (rows: BomIngredientRow[]): number =>
    rows.reduce((sum, row) => sum + computeIngredientCost(row), 0);
